@if (!store.isSummary) {
    <section>
        <ap-previous-button (click)="previousQuestion()"></ap-previous-button>
    </section>
}

@if (showEnergyLabel()) {
    <energy-label-radio></energy-label-radio>
}
